import { accountState } from '@/app/model/store/domain/types.ts'

export default <accountState> {
  accountData: [],
  allFieldData: [],
  choiceAccountType: 0,
  searchText: '',
  sortNum: '2',
  sortAsc: true
}
